<template>
  <FlexTable class="diets-table">
    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" />
    <transition-group name="diets-transition">
      <div
        class="flex-trow"
        v-for="(diet, index) in dataDiets.slice(startIndex, endIndex)"
        :key="'diet-'+diet.id"
      >
        <div class="remove-diet" @click="showModal(startIndex + index)">x</div>
        <div class="right-menu">
          <div class="right-menu-btn" @click="goToDiet(diet.id)">Ir</div>
        </div>
        <div class="flex-td name-cell">{{diet.name}}</div>
      </div>
    </transition-group>
  </FlexTable>
</template>

<script>
import FlexTable from "./base/FlexTable";
import dietService from "../../services/dietService";

export default {
  name: "DietsTable",
  components: { FlexTable },
  model: {
    prop: "diets",
    event: "change"
  },
  props: {
    diets: {
      type: Array,
      default: function() {
        return [];
      }
    },
    perPage: {
      type: Number,
      default: 10
    }
  },
  methods: {
    showModal(index) {
      // we must pass object params with all the information
      let diet = this.dataDiets[index];
      const params = {
        title: "Eliminar pauta",
        text:
          'Estas seguro que quieres eliminar la pauta "' +
          diet.name +
          '"?',
        // we are passing callback method for our confirm button
        onConfirm: () => {
          return this.deleteDiet(index);
        }
      };
      // now we can call function that will reveal our modal
      this.$deleteModal.show(params);
    },
    deleteDiet: function(index) {
      dietService.delete_diet_plan({ id: this.dataDiets[index].id }).then(
        data => {
          this.dataDiets.splice(index, 1);
          this.$toasted.success(data.message);
        },
        error => {
          this.$toasted.error("Ha ocurrido un error!");
          console.error(error);
        }
      );
    },
    goToDiet: function(id) {
      this.$router.push({ name: "diet", params: { id: id } });
    }
  },
  watch: {
    dataDiets: function(val) {
      this.$emit("change", val);
    },
    diets: function(val) {
      this.dataDiets = val;
    }
  },
  data: function() {
    return {
      dataDiets: this.diets,
      currentPage: 1
    };
  },
  computed: {
    rows() {
      return this.dataDiets.length;
    },
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      return this.currentPage * this.perPage;
    }
  }
};
</script>

<style scoped lang="scss">
.diets-table {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px;
  width: 100%;

  & span {
    width: 100%;
  }
}

.name-cell {
  padding-left: 3rem;
}

.flex-trow {
  position: relative;
  border-left: 1px solid $gray-500;
  border-right: 1px solid $gray-500;
  border-bottom: 1px solid $gray-300;

  & .right-menu {
    position: absolute;
    height: 100%;
    right: 0;
    display: flex;

    & .right-menu-btn {
      border-left: 1px solid $gray-500;
      padding: 0.75rem;
      min-width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: rgb(23, 162, 184);
      color: white;
      height: 100%;
    }

    & .right-menu-btn:hover {
      background-color: rgb(21, 146, 165);
    }
  }

  &:first-child {
    border-top: 1px solid $gray-500;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    & .right-menu .right-menu-btn:last-child {
      border-top-right-radius: 10px;
    }
  }

  &:last-child {
    border-bottom: 1px solid $gray-500;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

    & .right-menu .right-menu-btn:last-child {
      border-bottom-right-radius: 10px;
    }
  }

  & .remove-diet {
    display: none;
    position: absolute;
    margin: -0.5px;
    height: 100%;
    align-items: center;
    width: 32px;
    justify-content: center;
    color: black;
    background-color: rgba(grey, 0.1);
  }

  &:hover .remove-diet {
    display: flex;
    cursor: pointer;
  }

  &:first-child .remove-diet {
    border-top-left-radius: 10px;
  }

  &:last-child .remove-diet {
    border-bottom-left-radius: 10px;
  }
}

.flex-td {
  justify-content: flex-start;
  text-align: left;
  border: none;
}

.diets-transition-enter-active,
.diets-transition-leave-active {
  transition: opacity 0.2s;
}

.diets-transition-enter,
.diets-transition-leave-to {
  opacity: 0;
}

.diets-transition-leave,
.diets-transition-enter-to {
  opacity: 1;
}
</style>